import { jsxs as o, jsx as a } from "react/jsx-runtime";
import l from "../../utils/classNames.js";
import p from "../clearableInput/ClearableInput.js";
const i = (r) => {
  const { className: s, ...e } = r;
  return /* @__PURE__ */ o("div", { className: l("table-toolbar-search", "input-group", s), children: [
    /* @__PURE__ */ a("span", { className: "input-group-addon", children: /* @__PURE__ */ a("span", { className: "rioglyph rioglyph-search" }) }),
    /* @__PURE__ */ a(p, { ...e })
  ] });
};
export {
  i as default
};
//# sourceMappingURL=TableSearch.js.map
